module.exports = __webpack_public_path__ + "assets/css/logo-hapara-light.svg"